import { render, staticRenderFns } from "./ConsultaCatalogo.vue?vue&type=template&id=4b498ddc&scoped=true&"
import script from "./ConsultaCatalogo.vue?vue&type=script&lang=js&"
export * from "./ConsultaCatalogo.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaCatalogo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConsultaCatalogo.vue?vue&type=style&index=1&id=4b498ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b498ddc",
  null
  
)

export default component.exports